import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { fetchIdentityConfig } from "@/lib/identity/identity-api";

export function SecuritySettingsPage() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    fetchIdentityConfig().then(setCfg).catch(() => setCfg(null));
  }, []);

  return (
    <div className="max-w-lg mx-auto px-4 py-24" data-testid="security-settings">
      <Card>
        <CardHeader>
          <CardTitle>Security & verification</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm text-muted-foreground">
          <p>
            Email verification:{" "}
            <strong className="text-foreground">
              {cfg?.email_verification_required ? "Required for tracking" : "Optional"}
            </strong>
          </p>
          <p>
            Magic link sign-in:{" "}
            <strong className="text-foreground">{cfg?.magic_link_login_enabled ? "Enabled" : "Disabled"}</strong>
          </p>
          <p>
            WhatsApp verification:{" "}
            <strong className="text-foreground">
              {cfg?.whatsapp_verification_enabled ? "Enabled (future)" : "Not active"}
            </strong>
          </p>
          <p className="text-xs">
            Admin toggles are configured on the server. Contact messages are sent only to{" "}
            {cfg?.contact_email || "contact@vedapath.in"}.
          </p>
          <Link to="/settings/account" className="text-primary">
            Account settings
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
